module.exports = __webpack_public_path__ + "static/hr_capabilities_12-20b12f66a5c747c8b65d84a04a8de374.png";